import React from "react";
import { Stars } from "@/components/common/feedback/feedback-stars";

type RatingInputProps = {
	title: string;
	rating: number;
	onChange: (val: number) => void;
	error?: string;
};

export const RatingInput = ({ title, rating, onChange, error }: RatingInputProps) => {
	return (
		<div className="space-y-2">
			<h2 className="text-base font-semibold lg:text-lg">{title}</h2>
			<div className="w-min">
				<Stars rating={rating} setRating={onChange} />
			</div>
			{error && <p className="text-sm text-red-500">{error}</p>}
		</div>
	);
};
